﻿$.fn.dxCtrlBuilderEmailStyleFont = function custom_dxCtrlBuilderEmailStyleFont(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylefont dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleFont(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleFont = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        var $Table = $("<table/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        //font
        var $Td = $("<td style='width:60%;'/>").appendTo($Tr)
        var lstFont =
            "Roboto, Arial, Helvetica, sans-serif;" +
            "Arial, Helvetica, sans-serif;" +
            "Helvetica, Arial, sans-serif;" +
            "Verdana, Geneva, sans-serif;" +
            "Tahoma, Verdana, Segoe UI, sans-serif;" +
            "Trebuchet MS, Helvetica, sans-serif;" +
            "Georgia, Times New Roman, serif;" +
            "Times New Roman, Times, serif;" +
            "Courier New, Courier, monospace"
        lstFont = lstFont.split(";")
        //var lstFont = "Andale Mono;Arial;Arial Black;Book Antiqua;Comic Sans MS;Courier New;Georgia;Helvetica;Impact;Symbol;Tahoma;Terminal;Times New Roman;Trebuchet MS;Verdana;Webdings;Wingdings".split(";")
        if (option.allowDefaut) lstFont.unshift("")
        var valueFontFamily = lstFont.filter(function (o) { return o == option.value["font-family"] })[0]
        $("<div/>").appendTo($Td).dxCtrlSelectBox({
            labelMode: "floating",
            label: "Police",
            dataSource: lstFont,
            value: valueFontFamily,
            onValueChanged: function (e) {
                var newValue = e.value
                option.onValueChanged({ values: [{ prop: "font-family", value: newValue, oldValue: valueFontFamily }] })
                valueFontFamily = newValue
            }
        })
        //taille
        var ds = ["", "8px", "10px", "11px", "12px", "14px", "16px", "18px", "20px", "24px", "30px", "36px"]
        if (option.allowDefaut) ds.unshift("")
        var $Td = $("<td style='width:40%;padding-left:10px;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlSelectBox({
            labelMode: "floating",
            label: "Taille police",
            dataSource: ds,
            value: option.value["font-size"],
            onValueChanged: function (e) {
                var newValue = e.value
                option.onValueChanged({ values: [{ prop: "font-size", value: newValue, oldValue: option.value["font-size"] }] })
                option.value["font-size"] = newValue
            }
        })

        if (option.showAlign) {
            //alignement
            $("<div style='margin:5px 0;'/>").appendTo(container).dxCtrlWidgetAlignement({
                allowDefaut: option.allowDefaut,
                value: option.value["text-align"],
                onValueChanged: function (e) {
                    option.onValueChanged(e)
                }
            })
        }

        //B
        $("<div style='margin:5px 0;'/>").appendTo(container).dxCtrlBuilderEmailStyleFontBold({
            allowDefaut: option.allowDefaut,
            value: option.value["font-weight"],
            onValueChanged: function (e) {
                option.onValueChanged(e)
            }
        })

        //U
        $("<div style='margin:5px 0;'/>").appendTo(container).dxCtrlBuilderEmailStyleFontBoldUnderline({
            allowDefaut: option.allowDefaut,
            value: option.value["text-decoration"],
            onValueChanged: function (e) {
                option.onValueChanged(e)
            }
        })

        //I
        $("<div style='margin:5px 0;'/>").appendTo(container).dxCtrlBuilderEmailStyleFontItalic({
            allowDefaut: option.allowDefaut,
            value: option.value["font-style"],
            onValueChanged: function (e) {
                option.onValueChanged(e)
            }
        })


        var $Table = $("<table style='margin-top:10px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        //Line-height
        if (typeof option.value["line-height"] != 'undefined' && option.value["line-height"].contains("px")) option.value["line-height"] = option.value["line-height"].replace("px", "") / 8
        var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlSelectBox({
            labelMode: "floating",
            label: "Interligne",
            placeholder: "Sélectionner...",
            dataSource: ["", "50%", "60%", "70%", "80%", "90%", "100%", "110%", "120%", "130%", "140%", "150%", "200%"],
            value: option.value["line-height"],
            onValueChanged: function (e) {
                var newValue = e.value
                option.onValueChanged({ values: [{ prop: "line-height", value: newValue, oldValue: option.value["line-height"] }] })
                option.value["line-height"] = newValue
            }
        })
        var $Td = $("<td style='width:50%;padding-left:10px;'/>").appendTo($Tr)
        //Espace lettre
        $("<div/>").appendTo($Td).dxCtrlSelectBox({
            labelMode: "floating",
            label: "Espace lettre",
            placeholder: "Sélectionner...",
            dataSource: ["", "0px", "1px", "2px", "3px", "4px", "5px", "6px", "7px"],
            value: option.value["letter-spacing"],
            onValueChanged: function (e) {
                var newValue = e.value
                option.onValueChanged({ values: [{ prop: "letter-spacing", value: newValue, oldValue: option.value["letter-spacing"] }] })
                option.value["letter-spacing"] = newValue
            }
        })

        //Color
        $("<div  style='margin:5px 0;'/>").appendTo(container).dxCtrlColorPicker({
            title: "Couleur police",
            value: option.value["color"],
            titlePaletteSelect: "Couleur dans votre email",
            getPaletteSelect: option.dxBuilderEmailPage.mGetLstColor,
            onValueChanged: function (e) {
                var newValue = e.value
                option.onValueChanged({ values: [{ prop: "color", value: newValue, oldValue: option.value["color"] }] })
                option.value["color"] = newValue
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}